import {
    forwardRef,
    type HTMLProps,
    useCallback,
    useEffect,
    useState,
} from "react";
import FontAwesomeLight from "../../Utilities/Platform/FontAwesome/FontAwesomeLight";

type Props = Omit<HTMLProps<HTMLInputElement>, "type" | "ref">;

const PasswordInput = forwardRef<HTMLInputElement, Props>(({ className, ...props }, ref) => {
    const [ preview, setPreview ] = useState(false);

    const classes = [ "pr-12" ];

    if(typeof className === "string") {
        classes.push(className);
    }

    const onShow = () => {
        setPreview(true);
    };

    const onHide = useCallback(() => {
        setPreview(false);
    }, []);

    useEffect(() => {
        window.addEventListener("blur", onHide);

        return () => {
            window.removeEventListener("blur", onHide);
        };
    }, [ onHide ]);

    return (
        <div className="relative">
            <input
                ref={ref}
                type={preview ? "text" : "password"}
                className={classes.join(" ")}
                {...props}
            />
            <button
                type="button"
                className={
                    "absolute button right-0 top-0 bottom-0 bg-transparent w-8 m-2 p-0" +
                    (preview ? "" : " text-neutral-500 hover:text-neutral-600")
                }
                onMouseDown={onShow}
                onMouseUp={onHide}
                onMouseOut={onHide}
                onTouchStart={onShow}
                onTouchEnd={onHide}
                tabIndex={-1}
            >
                <FontAwesomeLight
                    icon={preview ? "eye" : "eye-slash"}
                    ignoreClass
                />
            </button>
        </div>
    );
});

PasswordInput.displayName = "PasswordInput";

export default PasswordInput;
